import { selectFromOrderDeliveryProgressDto } from '../../models';

export const OrderDeliveryProgressQuery = selectFromOrderDeliveryProgressDto()
  .id
  .delivered
  .missed
  .toString();
